import chatNotificationWav from "@/assets/sounds/톡톡.wav"
import patientReceptionWav from "@/assets/sounds/환자접수.wav"
import treatmentEndWav from "@/assets/sounds/치료종료음.wav"

export const NOTIFICATION_SOUND_FILES = {
  chatNotification: chatNotificationWav,
  kioskReception: patientReceptionWav,
  generalReception: patientReceptionWav,
  treatmentEnd: treatmentEndWav,
} as const

export type NotificationSoundKey = keyof typeof NOTIFICATION_SOUND_FILES
